import * as api from '../connectivity/api.runscript';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

let fileDownload = require('react-file-download');


export function* doRequestTriggerRunscript(action) {
    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'runscript.doRequestTriggerRunscript',
            overlay: true
        }
    });

    try{
        const { assignmentId } = action.payload,
            runscript_result = yield call(api.triggerRunscript, assignmentId)
        ;

        yield put({
            type: types.RUNSCRIPT__REQUESTED__SUCCEEDED,
            payload : runscript_result
        });
    } catch (e) {
        yield put({
            type: types.RUNSCRIPT__REQUESTED__FAILED,
            payload: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'runscript.doRequestTriggerRunscript',
            overlay: true
        }
    });
}

export function* doRequestTriggerRunscriptSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'runscript.doRequestTriggerRunscript',
            overlay: true
        }
    });
}

export function* doRequestTriggerRunscriptFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'runscript.doRequestTriggerRunscript',
            overlay: true
        }
    });
}

export function* doRequestRunscriptOutput(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'runscript.doRequestRunscriptOutput',
        }
    });

    try{
        const { assignmentId, userId, timestamp } = action.payload,
            file = yield call(api.getRunscriptOutput, assignmentId, userId, timestamp)
        ;

        yield put({
            type: types.RUNSCRIPT__OUTPUT__REQUESTED__SUCCEEDED,
            file: file,
            file_name : `runscript-output-${timestamp}.txt`
        });
    } catch (e) {
        yield put({
            type: types.RUNSCRIPT__OUTPUT__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'runscript.doRequestRunscriptOutput',
        }
    });

    yield put(hideLoading());
}

export function* doRequestRunscriptOutputSucceeded(action) {
    yield (fileDownload(action.file, action.file_name));

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File: "+action.file_name+" downloaded",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'runscript.doRequestRunscriptOutput'
        }
    });
}

export function* doRequestRunscriptOutputFailed(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Failed to download latest runscript report.",
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'runscript.doRequestRunscriptOutput'
        }
    });
}

export function* doRequestLatestRunscripts(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'runscript.doRequestLatestRunscripts',
        }
    });

    try{
        const { assignmentId, userId } = action.payload,
            runscripts = yield call(api.getLatestRunscripts, assignmentId, userId)
        ;

        yield put({
            type: types.RUNSCRIPTS__LATEST__REQUESTED__SUCCEEDED,
            payload: { runscripts }
        });
    } catch (e) {
        yield put({
            type: types.RUNSCRIPTS__LATEST__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'runscript.doRequestLatestRunscripts',
        }
    });

    yield put(hideLoading());
}

export function* doRequestLatestRunscriptsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'runscript.doRequestLatestRunscripts'
        }
    });
}

export function* doRequestLatestRunscriptsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'runscript.doRequestLatestRunscripts'
        }
    });
}

export function* watchRequestTriggerRunscript() {
    yield* takeLatest(types.RUNSCRIPT__REQUESTED, doRequestTriggerRunscript);
}

export function* watchRequestTriggerRunscriptSucceeded() {
    yield* takeLatest(types.RUNSCRIPT__REQUESTED__SUCCEEDED, doRequestTriggerRunscriptSucceeded);
}

export function* watchRequestTriggerRunscriptFailed() {
    yield* takeLatest(types.RUNSCRIPT__REQUESTED__FAILED, doRequestTriggerRunscriptFailed);
}

export function* watchRequestRunscriptOutput() {
    yield* takeLatest(types.RUNSCRIPT__OUTPUT__REQUESTED, doRequestRunscriptOutput);
}

export function* watchRequestRunscriptOutputSucceeded() {
    yield* takeLatest(types.RUNSCRIPT__OUTPUT__REQUESTED__SUCCEEDED, doRequestRunscriptOutputSucceeded);
}

export function* watchRequestRunscriptOutputFailed() {
    yield* takeLatest(types.RUNSCRIPT__OUTPUT__REQUESTED__FAILED, doRequestRunscriptOutputFailed);
}

export function* watchRequestLatestRunscripts() {
    yield* takeLatest(types.RUNSCRIPTS__LATEST__REQUESTED, doRequestLatestRunscripts);
}

export function* watchRequestLatestRunscriptsSucceeded() {
    yield* takeLatest(types.RUNSCRIPTS__LATEST__REQUESTED__SUCCEEDED, doRequestLatestRunscriptsSucceeded);
}

export function* watchRequestLatestRunscriptsFailed() {
    yield* takeLatest(types.RUNSCRIPTS__LATEST__REQUESTED__FAILED, doRequestLatestRunscriptsFailed);
}



/** WEBPACK FOOTER **
 ** ./src/sagas/runscript.saga.js
 **/